export default {
  // 並び順をidで昇順並び替え
  sort(element) {
    if (element) {
      return element.slice().sort(function (a, b) {
        if (a.id < b.id) return -1;
        if (a.id > b.id) return 1;
        return 0;
      });
    }
  },

  // 並び順をdisplay_orderで昇順並び替え
  sortByDisplayOrder(element) {
    if (element) {
      return element.slice().sort(function (a, b) {
        if (a.display_order < b.display_order) return -1;
        if (a.display_order > b.display_order) return 1;
        return 0;
      });
    }
  },

  // stamped_atが新しい順に並び替え
  sortByDateTimeLaterFirst(element) {
    if (element) {
      return element.slice().sort(function (a, b) {
        if (a.stamped_at < b.stamped_at) return 1;
        if (a.stamped_at > b.stamped_at) return -1;
        return 0;
      });
    }
  },

  checkIsSubscription(masterBookId) {
    // stringの場合もあるので、その場合は変換
    if (typeof masterBookId === "string") {
      masterBookId = Number(masterBookId);
    }
    const subscriptionMasterBookIDs = [224, 225, 226, 227, 228];
    return subscriptionMasterBookIDs.includes(masterBookId);
  },
  getQueryParams(url) {
    const paramArr = url.slice(url.indexOf('?') + 1).split('&');
    const params = {};
    
    paramArr.map(param => {
      const [key, val] = param.split('=');
      params[key] = decodeURIComponent(val);
    });
    return params;
  }
};
